
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Users } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface UsersManagementHeaderProps {
  onRefresh: () => void;
}

const UsersManagementHeader: React.FC<UsersManagementHeaderProps> = ({ onRefresh }) => {
  return (
    <CardHeader>
      <div className="flex justify-between items-center">
        <div>
          <CardTitle className="flex items-center">
            <Users className="mr-2 h-5 w-5" />
            User Management
          </CardTitle>
          <CardDescription>
            Manage users for this instance
          </CardDescription>
        </div>
        <div className="flex gap-2">
          <Button 
            onClick={onRefresh} 
            variant="outline"
            size="sm"
          >
            Refresh
          </Button>
        </div>
      </div>
    </CardHeader>
  );
};

export default UsersManagementHeader;
